// @ts-nocheck
/* eslint-disable */
export const chevronRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>`,
    name: 'chevron-right' as const
};